import appConfig from '../../../../app.config.json';
import logging from '../services/logging';
import { urlFromConfig, Config } from './axios';

export const STRAPI_URL = appConfig.strapiUrl || '';

// Cloudflare Access service token for protected (dev/staging) Strapi instances. Read from server-side env only,
// never app.config.json, so the secret is not shipped in the client bundle.
const getAccessHeaders = (): Record<string, string> => {
  const clientId = process?.env?.CF_ACCESS_CLIENT_ID;
  const clientSecret = process?.env?.CF_ACCESS_CLIENT_SECRET;

  if (!clientId || !clientSecret) return {};

  return {
    'CF-Access-Client-Id': clientId,
    'CF-Access-Client-Secret': clientSecret,
  };
};

const strapiAxios = async <T = any>(config: Config): Promise<Response & { data: T }> => {
  const url = urlFromConfig(config);

  try {
    logging.logCrumb({
      message: 'strapi_request',
      metaData: {
        url,
        method: 'GET',
      },
    });

    const result = await fetch(url, {
      method: config.method || 'GET',
      headers: getAccessHeaders(),
    });
    const data = await result.json();

    return { ...result, data };
  } catch (error: any) {
    if (error.response) {
      logging.logError(new Error(`Strapi API error ${error.response.status} on ${url}`));
    }

    throw error;
  }
};

export default strapiAxios;
